import { render, staticRenderFns } from "./starshop_data.vue?vue&type=template&id=8232a188"
import script from "./starshop_data.vue?vue&type=script&lang=js"
export * from "./starshop_data.vue?vue&type=script&lang=js"
import style0 from "./starshop_data.vue?vue&type=style&index=0&id=8232a188&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports